import type { ContextsApp } from '../../context-app'

export class UtilisateurBase {
  readonly userId: string
  readonly nom: string | null
  readonly prenom: string | null
  readonly prenomNom: string | null
  readonly email: string
  readonly contextsApp: ContextsApp | null
  readonly estInterne: boolean

  constructor(
    userId: string,
    email: string,
    nom: string | null,
    prenom: string | null,
    contextsApp: ContextsApp | null,
    estInterne: boolean,
  ) {
    this.userId = userId
    this.email = email
    this.nom = nom
    this.prenom = prenom
    this.prenomNom = nom || prenom ? [prenom, nom].filter((e) => !!e).join(' ') : null
    this.contextsApp = contextsApp
    this.estInterne = estInterne
  }

  clone(replace: Partial<UtilisateurBase> = {}) {
    return new UtilisateurBase(
      replace.userId === undefined ? this.userId : replace.userId,
      replace.email === undefined ? this.email : replace.email,
      replace.nom === undefined ? this.nom : replace.nom,
      replace.prenom === undefined ? this.prenom : replace.prenom,
      replace.contextsApp === undefined ? this.contextsApp : replace.contextsApp,
      replace.estInterne === undefined ? this.estInterne : replace.estInterne,
    )
  }

  get prenomNomAffichage(): string {
    return this.prenomNom || this.emailAffichage
  }

  get emailAffichage(): string {
    return this.email
  }
}

export class Utilisateur extends UtilisateurBase {
  readonly estImpersonnalisé: boolean
  readonly impresonnaliseNom: string | null
  readonly impresonnalisePrenom: string | null
  readonly impresonnalisePrenomNom: string | null
  readonly impresonnaliseEmail: string
  readonly impresonnaliseToken: string

  constructor(
    base: UtilisateurBase,
    impresonnaliseToken: string,
    impresonnaliseEmail: string,
    impresonnaliseNom: string | null,
    impresonnalisePrenom: string | null,
  ) {
    super(base.userId, base.email, base.nom, base.prenom, base.contextsApp, base.estInterne)
    this.estImpersonnalisé = true
    this.impresonnaliseToken = impresonnaliseToken
    this.impresonnaliseEmail = impresonnaliseEmail
    this.impresonnaliseNom = impresonnaliseNom
    this.impresonnalisePrenom = impresonnalisePrenom
    this.impresonnalisePrenomNom =
      impresonnaliseNom || impresonnalisePrenom
        ? [impresonnalisePrenom, impresonnaliseNom].filter((e) => !!e).join(' ')
        : null
  }

  override clone(replace: Partial<Utilisateur> = {}) {
    const utilisateurBase = super.clone(replace)

    return new Utilisateur(
      utilisateurBase,
      replace.impresonnaliseToken === undefined ? this.impresonnaliseToken : replace.impresonnaliseToken,
      replace.impresonnaliseEmail === undefined ? this.impresonnaliseEmail : replace.impresonnaliseEmail,
      replace.impresonnaliseNom === undefined ? this.impresonnaliseNom : replace.impresonnaliseNom,
      replace.impresonnalisePrenom === undefined ? this.impresonnalisePrenom : replace.impresonnalisePrenom,
    )
  }

  get prenomNomAffichage(): string {
    if (this.estImpersonnalisé) {
      return this.impresonnalisePrenomNom || this.impresonnaliseEmail
    } else {
      return super.prenomNomAffichage
    }
  }

  get prenomNomInterne(): string {
    return super.prenomNomAffichage
  }

  get emailAffichage(): string {
    return this.impresonnaliseEmail
  }
}
